import {BASE_API_URL, REQUEST_TIMEOUT} from "./config";
import {createAxios} from './axios';

const collateralsApi = createAxios({
    baseURL: BASE_API_URL + '/collaterals'
})

export const getCollateralsDatatable = async (params) => {
    if (params && params.filters && params.filters.length > 0) {
        params.facility = params.filters[3][0];
        params.department = params.filters[4][0];
        params.clinic = params.filters[5][0];
    }

    return await collateralsApi.get('', {
        timeout: REQUEST_TIMEOUT,
        params: {
            page: params.page,
            draw: 1,
            start: params.start,
            length: params.length,
            search: params.search,
            sortOrder: params.sortOrder,
            sortDirection: params.sortDirection,
            appointmentId: params.appointmentId,
            facility: params.facility,
            department: params.department,
            clinic: params.clinic,
            label: params.label,
            sortColumn: params?.sortColumn
        }
    });
}

export const getCollateralById = id => {
    return collateralsApi.get(`/${id}`);
}

export const getCollateralList = location => {
    return collateralsApi.get('', {
        params: {
            locationId: location
        }
    })
}

export const addCollateral = params => {
    // should turn this into formdata
    return collateralsApi.post('', {
        name: params.name,
        description: params.description,
        locationId: params.locationId,
        url: params.url,
        file: params.file
    })
}

export const deleteCollateral = id => {
    return collateralsApi.delete(`/${id}`);
}

export const createCollateral = form => {
    return collateralsApi.post(``, form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
};

export const fetchCollaterals = () => {
    return collateralsApi.get();
}

export const getCollateralURL = id => {
    return collateralsApi.get(`${id}/url`);
}

export const getCollateralFile = id => {
    return `${BASE_API_URL}/collaterals/${id}/file`
}

export const updateCollateral = (id, form) => {
    return collateralsApi.put(`/${id}`,form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
};